import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"letters-x"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M16 5L16 7.11979C16 7.36471 15.9101 7.60111 15.7474 7.78416L12 12M8 5L8.00001 7.1198C8.00001 7.36472 8.08989 7.60111 8.2526 7.78416L12 12M12 12L8.25259 16.2158C8.08988 16.3989 8.00001 16.6353 8.00001 16.8802L8 19M12 12L15.7474 16.2158C15.9101 16.3989 16 16.6353 16 16.8802L16 19","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const LettersX = Vue.extend<IconProps>({
  name: 'LettersXIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'letters-x',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default LettersX;
